module.exports = "<input style=\"width: 100%;\" [(ngModel)]=\"value\" (keydown)=\"isNumberKey($event)\" (change)=\"onChange()\" (blur)=\"onBlur()\" [disabled]=\"disabled\" class=\"form-control \">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-numbers/app-numbers.component.html
// module id = ./src/app/components/app-numbers/app-numbers.component.html
// module chunks = main